'use client';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { signIn } from 'next-auth/react';

import Image from '@/components/v2/Image';
import Button from '@/components/v4/Button';
import { IconProps } from '@/icons/common';
import { trackKakaoLoginError } from '@/lib/datadog';

const SpecialClient = () => {
  const router = useRouter();

  const handleClickSignIn = () => {
    router.push('/special/sign-in');
  };

  const handleSignInKakao = async () => {
    const result = await signIn('kakao', {
      callbackUrl: '/special/gateway/kakao',
    });
    if (result?.error) trackKakaoLoginError(result.error, result.status);
  };

  return (
    <>
      <div className="flex flex-1 justify-center items-center px-4 h-full">
        <div>
          <Button
            className="w-full px-6 justify-between max-w-[306px]"
            onClick={handleSignInKakao}
            variant="contained"
            color="kakao"
            height={60}
          >
            <Image src="/img/special/logo_kakao.png" width={24} height={24} alt="카카오_아이콘" />
            <span className="text-[18px] text-[#000000D9]">카카오 계정으로 시작하기</span>
            <div />
          </Button>

          <Button
            className="w-full mt-3 px-6 justify-between max-w-[306px]"
            variant="contained"
            color="orange"
            height={60}
            href={'/special/sign-up/email'}
            data-gtm-id="special-email-signup"
            as={Link}
          >
            <EmailIcon className="size-[26px]" />
            <span className="text-[18px]">이메일로 회원가입하기</span>
            <div />
          </Button>

          <div className="mt-6 flex gap-2.5 items-center justify-center">
            <p className="text-cds-coolgray-80 text-center font-medium">댓글몽 회원이신가요? </p>
            <button
              className="text-cds-orange-55 font-bold"
              onClick={handleClickSignIn}
              data-gtm-id="special-signin-button"
            >
              로그인
            </button>
          </div>
        </div>
      </div>
      {/* <SpecialModal isOpen={isOpen} close={handleCloseModal}>
        <SignIn />
      </SpecialModal> */}
    </>
  );
};

const EmailIcon = (props: IconProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
  >
    <path
      d="M22.2 3.5H3.8C2.535 3.5 1.5115 4.56875 1.5115 5.875L1.5 20.125C1.5 21.4312 2.535 22.5 3.8 22.5H22.2C23.465 22.5 24.5 21.4312 24.5 20.125V5.875C24.5 4.56875 23.465 3.5 22.2 3.5ZM21.74 8.54688L13.6095 13.7956C13.2415 14.0331 12.7585 14.0331 12.3905 13.7956L4.26 8.54688C4.14469 8.48003 4.04371 8.38972 3.96317 8.28141C3.88264 8.17311 3.82422 8.04905 3.79146 7.91675C3.7587 7.78446 3.75228 7.64667 3.77258 7.51174C3.79288 7.37681 3.83949 7.24753 3.90957 7.13173C3.97966 7.01594 4.07177 6.91603 4.18034 6.83806C4.2889 6.76008 4.41165 6.70567 4.54117 6.6781C4.67069 6.65054 4.80428 6.6504 4.93385 6.67769C5.06342 6.70498 5.18628 6.75913 5.295 6.83687L13 11.8125L20.705 6.83687C20.8137 6.75913 20.9366 6.70498 21.0662 6.67769C21.1957 6.6504 21.3293 6.65054 21.4588 6.6781C21.5883 6.70567 21.7111 6.76008 21.8197 6.83806C21.9282 6.91603 22.0203 7.01594 22.0904 7.13173C22.1605 7.24753 22.2071 7.37681 22.2274 7.51174C22.2477 7.64667 22.2413 7.78446 22.2085 7.91675C22.1758 8.04905 22.1174 8.17311 22.0368 8.28141C21.9563 8.38972 21.8553 8.48003 21.74 8.54688Z"
      fill="white"
    />
  </svg>
);
export default SpecialClient;
